export default __webpack_public_path__ + "c90f5bba0e21598d1bd2731c85c24223.png";